<script setup>
import NotificationItem from "@/components/Notification/NotificationItem.vue";
import { useNotifications } from "@/composables/useNotifications";
import { computed } from "vue";

const props = defineProps({
  position: {
    type: String,
    default: "bottom-right",
    validator: (value) => [
      "top-left", "top-center", "top-right",
      "bottom-left", "bottom-center", "bottom-right"
    ].includes(value)
  },
  maxNotifications: {
    type: Number,
    default: 5
  }
});

const { notifications, removeNotification } = useNotifications();

// Ограничиваем количество показываемых уведомлений
const visibleNotifications = computed(() => {
  return notifications.value.slice(-props.maxNotifications);
});

const handleRemove = (id) => {
  removeNotification(id);
};

// Классы для позиционирования
const positionClasses = computed(() => {
  const baseClass = "notification-block";
  return [baseClass, `${baseClass}--${props.position}`];
});</script>

<template>
  <div :class="positionClasses">
    <TransitionGroup name="list">
      <NotificationItem
        v-for="notification in visibleNotifications"
        :key="notification.id"
        :notification="notification"
        @close="handleRemove"
      />
    </TransitionGroup>
  </div>
</template>

<style scoped lang="scss">
.notification-block {
  position: fixed;
  z-index: 5000;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  pointer-events: none;

  // Позиционирование по углам и сторонам
  &--top-left {
    top: 0;
    left: 0;
    align-items: flex-start;
  }

  &--top-center {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    align-items: center;
  }

  &--top-right {
    top: 0;
    right: 0;
    align-items: flex-end;
  }

  &--bottom-left {
    bottom: 0;
    left: 0;
    align-items: flex-start;
    flex-direction: column-reverse;
  }

  &--bottom-center {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    align-items: center;
    flex-direction: column-reverse;
  }

  &--bottom-right {
    bottom: 0;
    right: 0;
    align-items: flex-end;
    flex-direction: column-reverse;
  }

  // Включаем pointer-events для уведомлений
  :deep(.notification-item) {
    pointer-events: auto;
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.4s ease;
}

.list-enter-from,
.list-leave-to {
  transform: translateX(100px) scale(0.95);
  opacity: 0;
}

.list-move {
  transition: transform 0.4s ease;
}
</style>